import '../css/consent.css';
import '../css/popup.css';
import { ReactComponent as Important } from '../assert/important.svg';
import React, { Component } from 'react';
import axios from 'axios';
import * as jose from 'jose';
import { withTranslation, Trans } from 'react-i18next'
import Popup from 'reactjs-popup';
import Loading from './5gLoading';

class consent extends Component{
    constructor(props) {
        super(props);
        this.state = {
            isInApp: false,
            token: null,
            brand: "o2f",
            msisdn: "",
            cnMsisdn: "",
            isConsent: false,
            showConsent: false,
            isBack: true,
            agree: false,
            code: null,
            consent: false
        };

        this.popupRef = React.createRef();
        this.loadingRef = React.createRef();

        this.getQueryParam = this.getQueryParam.bind(this);
        this.getInfo = this.getInfo.bind(this);
        this.toggleAgreement = this.toggleAgreement.bind(this);
        this.back = this.back.bind(this);
        this.authorize = this.authorize.bind(this);
        this.cancelAuthorization = this.cancelAuthorization.bind(this);
        this.updateConsentStatus = this.updateConsentStatus.bind(this);
        this.updateStateFromJwt = this.updateStateFromJwt.bind(this);
        this.checkCodeInResponse = this.checkCodeInResponse.bind(this);
        this.closePopupAndBack = this.closePopupAndBack.bind(this);
        this.toggleShowLoading = this.toggleShowLoading.bind(this);
    }
    async componentDidMount(){
        const queryParams = this.getQueryParam();
        await this.getInfo(queryParams);
    }
    getQueryParam() {
        const {sid, msisdn, ticket, isTest} = this.props;
        let {brand} = this.props;

        brand = brand === "csl"
            ?"o2f"
            :brand === "cs_postpaid"
                ?"cspp":brand;

        console.log(`brand: ${brand},msisdn: ${msisdn}, sid: ${sid}, ticket: ${ticket}`);
        
        const queryParams = {
            brand,
            sid,
            ticket,
            isInApp: (ticket==null && sid!=null),
            isTest
        };
        
        this.setState(()=>(queryParams));
        return queryParams;
    }
    async getInfo({sid, ticket, isInApp, isTest}){
        console.log("Start getting Information");

        let url = `${process.env.REACT_APP_SDEWEB_API_URL}/api/Auth/app/${sid}`;

        if(!isInApp){
            url = `${process.env.REACT_APP_SDEWEB_API_URL}/api/Auth/web/${this.props.msisdn}/${ticket}`;
        }
        if(isTest){
            url = `${process.env.REACT_APP_SDEWEB_API_URL}/api/Auth/test/57906604`;
        }
        try{
            const {data} = await axios.get(url);
            this.checkCodeInResponse({
                data,
                isInApp
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.toggleShowLoading();
            console.log("Finish getting Information");
        }
    }
    checkCodeInResponse({data, consent, isInApp}){
        console.log("Start checking response.");
        const { code, token } = data;
        let jwtObj, brand;
        if(token){
            jwtObj = jose.decodeJwt(token);
            brand = jwtObj.brand;
            brand = brand === "csl"
                ?"o2f"
                :brand === "cs_postpaid"
                    ?"cspp"
                    :brand;
        }

        if(code===401) {
            if(isInApp){
                window.location.href = `${brand === "1010"?process.env.REACT_APP_1010_SERVICEAPP_URL:process.env.REACT_APP_CSL_SERVICEAPP_URL}?goTo=LOGININAPPLINK-https%3A%2F%2F${process.env.REACT_APP_SDEWEB_API_DOMAIN}%2F1C2N%2F`;
            } else {
                window.web5gJS.loginWithCAS(`${process.env.REACT_APP_SDEWEB_API_URL}/`);
            }
        } else if(code==40302) {
            console.log("Entered by visitor");
            window.customWebToAppData('goHomePage');
            return;
        } else {
            this.updateStateFromJwt(token);
        }

        if([403, 40301, 422, 200, 500].includes(code)){
            if(
                (code === 200 && (consent != null || consent != undefined))
                || code !== 200
            ){
                this.popupRef.current.open();
            }
        }
        this.setState(()=>({
            code,
            isBack: !(code===200),
            consent,
            showConsent: !(code===401)
        }));
        console.log("Finish checking response.");
    }
    toggleAgreement(){
        this.setState(prevState => ({
            agree: !prevState.agree,
        }));
    }
    toggleShowLoading(){
        this.loadingRef.current.toggleShow();
    }
    back(e) {
            e.preventDefault();
        if(this.state.isInApp){
            console.log(`Redirect function customWebToAppData is called now.`)
            window.customWebToAppData("goBackPage");
        } else {
            const homepage = `${this.state.brand==="1010"?process.env.REACT_APP_5G_1010_PATH:process.env.REACT_APP_5G_CSL_PATH}/index.html?&redirectURL=home.html`;
            console.log(`Redirect: ${homepage}.`)
            window.top.window.location.href = homepage;
        }
    }
    async authorize(e) {
        e.preventDefault();
        this.toggleAgreement();
        this.toggleShowLoading();
        await this.updateConsentStatus({consent:true});
    }
    async cancelAuthorization(e) {
        e.preventDefault();
        this.toggleAgreement();
        this.toggleShowLoading();
        await this.updateConsentStatus({consent:false});
    }
    async updateConsentStatus({consent}){
        console.log("Start updating consent status.");
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.state.token}`
        };
        
        try{
            const {data} = await axios.post(`${process.env.REACT_APP_SDEWEB_API_URL}/api/Consent/`, {consent, smsLang: this.props.lang}, {headers});
            this.checkCodeInResponse({
                data,
                consent
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.toggleShowLoading();
            console.log("finish updating consent status.");
        }
    }
    updateStateFromJwt(token){
        console.log(`Any token in response? ${token?"Yes":"No"}`);
        if(token){
            const jwtObj = jose.decodeJwt(token);
            const {isConsent, cnMsisdn, msisdn, brand} = jwtObj;
            document.body.classList.add(brand==="1010"?"lOlO":brand);
            console.log("Save token information");
            this.setState(() => ({
                isConsent,
                cnMsisdn,
                msisdn,
                brand,
                token
            }));
        }
    }
    closePopupAndBack(e){
        this.popupRef.current.close();
        if(this.state.isBack){
            this.back(e);
        }
    }

    render() {
        const { t } = this.props;
        //Update app title if in app
        if(this.state.isInApp){
            const jsonObj = {
                "type" : "title",
                "content" : t("appTitle")
            }
            try{
                window.customWebToApp_updateApp("header",jsonObj);
            } catch (error){
                console.debug(error);
            }
        }
        
        let authStatusDisplay, formNameDisplay, serviceNoticeDisplay, agreementDisplay, submitBtn;
        if(this.state.isConsent) {
            formNameDisplay = t('authorizeCancelFormName');
            serviceNoticeDisplay = <p className="alreadyAuth">{t('serviceNoticeCancel')}</p>;
            authStatusDisplay = t('authorizeStatusAuthorized');
            agreementDisplay = <label htmlFor="agreement" className="alreadyAuth">{t('agreementCancel')}</label>;
            submitBtn = <button className="alreadyAuth" disabled={!this.state.agree} onClick={this.cancelAuthorization}>{t('authorizeCancel')}</button>;
        } else {
            formNameDisplay = t('authorizeFormName');
            serviceNoticeDisplay = <p className="notAuth">{t('serviceNoticeAuthorize')}</p>;
            authStatusDisplay = t('authorizeStatusNotYetAuthorized');
            agreementDisplay = <label htmlFor="agreement" className="notAuth">{t('agreementAuthorize')}</label>;
            submitBtn = <button className="notAuth" disabled={!this.state.agree} onClick={this.authorize}>{t('authorize')}</button>;
        }

        let communicationBigDataItineraryCardHref = `${process.env.REACT_APP_COMMUNICATION_BIG_DATA_ITINERARY_CARD_URL}`;
        let privacyStatementHref = `${process.env.REACT_APP_PRIVACY_STATEMENT_URL}?locale=${this.props.lang}`;


        if(this.state.isInApp){
            const serviceAppLink = (this.state.brand==="1010"?`${process.env.REACT_APP_1010_SERVICEAPP_URL}`:`${process.env.REACT_APP_CSL_SERVICEAPP_URL}`);
            
            communicationBigDataItineraryCardHref = `${serviceAppLink}?goTo=INAPPLINK-${communicationBigDataItineraryCardHref}`;
            privacyStatementHref = `${serviceAppLink}?goTo=INAPPLINK-${privacyStatementHref}`;
        }

        let brand = this.state.brand === "csl"
                ?"o2f"
                :this.state.brand === "cs_postpaid"
                    ?"cspp"
                    :this.state.brand;
        let modalTitle,message;
        switch (this.state.code) {
            case 403:
                modalTitle = t("alert403NotSubscribe1C2NTitle");
                message = t(`${brand}${this.state.isCorp?'Corp':'Mass'}Alert403NotSubscribe1C2N`);
                break;
            case 40301:
                modalTitle = t("alert40301CmNumberTitle");
                message = t(`${brand}Alert40301CmNumber`);
                break;
            case 422:
                modalTitle = t("failTitle");
                message = t(`${brand}Fail`);
                break;
            case 200:
                if(this.state.consent != null || this.state.consent != undefined){
                    modalTitle = this.state.consent?t("optinSuccessTitle"):t("optoutSuccessTitle");
                    message = this.state.consent?t(`${brand}OptinSuccess`):t(`${brand}OptoutSuccess`);
                }
                break;
            default:
                modalTitle = t("failTitle");
                message = t(`${brand}Fail`);
                break;
        }

        return(
            <div>
                <Loading ref={this.loadingRef}/>
                <div style={{display: this.state.showConsent?"block":"none"}}>
                    <section>
                        <h1>{t('title')}</h1>
                        <h4 className="consentName">{formNameDisplay}</h4>
                        <h4 className="serviceName">{t('serviceName')}</h4>
                        <p><Trans i18nKey="serviceContent1">"Telecommunication Data Based Travel Itinerary Card" is a non-profit, free of charge itinerary inquiry service jointly launched by China Academy of Information and Communications Technology, China Telecom, China Mobile, and China Unicom under the guidance of the Ministry of Industry and Information Technology (MIIT). It shows your past 7<sup>(2)</sup> days locations outside Mainland China and cities within Mainland China staying over 4 hours. </Trans><a href={communicationBigDataItineraryCardHref} target="_blank" rel="noopener noreferrer">{t('telecommunicationDataBasedTravelItineraryCardWebSite')}{t('simplifiedChinese')}</a></p>
                    </section>
                    <section className="mobileNumberSection">
                        <p>{t('mobileNumberCheck')}</p>
                        <div className="mobileNumber">
                            <div>
                                <label htmlFor="mobileNumberHk">{t('mobileNumberLabelHk')}</label><br/>
                                <input name="mobileNumberHk" disabled value={this.state.msisdn}/>
                                <br/>
                                <label htmlFor="mobileNumberChina">{t('mobileNumberLabelChina')}</label><br/>
                                <input name="mobileNumberChina" disabled value={this.state.cnMsisdn}/>
                            </div>
                            <div className={`authStatus ${this.state.isConsent?"alreadyAuth":"notAuth"}`}>
                                {authStatusDisplay}
                            </div>
                        </div>
                        <div className="serviceNotice">
                            {serviceNoticeDisplay}
                        </div>
                    </section>
                    <section className="confirmSection">
                        <div>
                            <div><Important/></div>
                            <div>{t('serviceContent2')}<a className="privacyStatement" href={privacyStatementHref} target="_blank" rel="noopener noreferrer">{t('privacyStatement')}</a></div>
                        </div>
                        <div>
                            <div><input name="agreement" type="checkbox" disabled={!this.state.msisdn || !this.state.cnMsisdn} checked={this.state.agree} onChange={this.toggleAgreement}/></div>
                            <div>{agreementDisplay}</div>
                        </div>
                        {submitBtn}
                    </section>
                    <section className="remarkSection">
                        <p>{t('remarkLabel')}</p>
                        <ol>
                            <li>{t('remark1')}</li>
                            <li>{t('remark2')}</li>
                            <li>{t('remark3')}</li>
                            <li>{t('remark4')}</li>
                        </ol>
                    </section>
                </div>
                <Popup
                    ref={this.popupRef}
                    closeOnDocumentClick={false}
                    onClose={this.closePopupAndBack}
                    repositionOnResize={true}
                >
                    <div className="modal">
                        <div className="modalTitle">{modalTitle}</div>
                        <div className="modalMessage">{message}</div>
                        <button className="modalBack" onClick={this.closePopupAndBack}>{t("back")}</button>
                    </div>
                </Popup>
            </div>
        )
    }
}

export default withTranslation()(consent);